// extracted by mini-css-extract-plugin
export var image = "gP_bS";